import React, { FC } from 'react';
import {
	SummaryBeantragteFoerderquote,
	SummaryBeantragteFoerderung,
	SummaryDatumDerEinreichung,
	SummaryGeplanteProjektAusgabe,
	SummaryGeplanteProjektLaufzeit,
	SummaryNameDerOrganisation,
	SummaryOrganisationAntragberechtigtAls,
	SummaryOrganisationFoerderQuote,
	SummaryProjektTitel,
	SummaryTitel,
	SummaryVerbundpartnerDetails,
	SummaryVorzeitigerVorhabenBeantragt,
	SummaryVorzeitigerVorhabenLaufzeit,
} from 'src/pages/private/online-antrag/antrag-components/AbschlussSeiteSummary';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import AbschlussSeiteBox, { GefoerderteSummeProgrammInfo } from '../../../../antrag-components/AbschlussSeiteBox';

const AbschlussAntragEmob: FC<{}> = () => {
	const { application } = useApplication();

	return (
		<>
			<SummaryTitel />

			<AbschlussSeiteBox>
				<SummaryDatumDerEinreichung />

				<SummaryProjektTitel />

				<SummaryNameDerOrganisation />
				<SummaryOrganisationAntragberechtigtAls />

				<SummaryOrganisationFoerderQuote />

				<SummaryVerbundpartnerDetails />

				<SummaryVorzeitigerVorhabenBeantragt />
				<SummaryGeplanteProjektLaufzeit />
				<SummaryVorzeitigerVorhabenLaufzeit />

				<SummaryGeplanteProjektAusgabe />
				<SummaryBeantragteFoerderung />
				<SummaryBeantragteFoerderquote />

				<GefoerderteSummeProgrammInfo application={application} />
			</AbschlussSeiteBox>
		</>
	);
};
export default AbschlussAntragEmob;
